//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  directives: {
    clickOutside: {
      bind(el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
          if (!(el === event.target || el.contains(event.target))) {
            binding.value(event)
          }
        }
        document.body.addEventListener('click', el.clickOutsideEvent)
      },
      unbind(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
      },
    },
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    items: {
      required: true,
      type: Array,
    },
    text: {
      required: false,
      default: '',
      type: String,
    },
    headline: {
      required: false,
      default: '',
      type: String,
    },
    hubPage: {
      type: Object,
      default() {},
    },
    image: {
      type: Object,
      default() {},
    },
    parentSlug: {
      required: true,
      default: '',
      type: String,
    },
  },

  data() {
    return {
      activeSubmenu: null,
      subMenuListensToMouseEvents: false,
    }
  },

  methods: {
    submenuClick() {
      if (this.userBranch !== '') {
        // eslint-disable-next-line no-undef
        const currentPageURL = window.location.href
        // eslint-disable-next-line no-undef
        window._mtm = window._mtm || []
        // eslint-disable-next-line no-undef
        window._mtm.push({
          event: 'form-Process-interaction',
          'event-category': 'form-Process-interaction',
          'event-action': `CLICK_LINK_URL - ${currentPageURL}`,
        })
      }
    },
    openSubMenu(index) {
      if (this.activeSubmenu === this.items[index]) {
        this.activeSubmenu = null
      } else {
        this.activeSubmenu = this.items[index]
      }
    },
    closeSubMenu() {
      this.activeSubmenu = null
    },
    close(id) {
      this.$emit('submenu:close', id)
    },
    url(url) {
      return this.$localeResolver.localePath({
        path: this.parentSlug !== '' ? `/${this.parentSlug}/${url}` : `/${url}`,
      })
    },
  },
}
